module.exports = __webpack_public_path__ + "static/media/GG.5d561c78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GG.svg
// module id = 259
// module chunks = 0